@if (visible()) {
<div class="toast-wrapper">
  <div class="toast-container">
    <div class="flex gap-3 flex-1">
      <span [class]="icon + ' toast-icon'"></span>
      <div class="flex flex-col gap-1">
        <div class="toast-title">{{ title }}</div>
        <div class="toast-message">{{ message }}</div>
      </div>
    </div>
    <button type="button" class="close-button" (click)="onClose()" aria-label="Close">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>
</div>
}

